import useAuth from './hooks/useAuth.js';


const HiUser = () => {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="row align-items-center mb-4">
                <div className="col text-start">
                    <h1 className="h4 mb-0 badge bg-warning">Chargement...</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="row align-items-center mb-4">
            <div className="col text-start">
                {!user ? (
                    <h1 className="h4 mb-0 badge bg-danger">No User</h1>
                ) : (
                    <h1 className="h4 mb-0">
                        Hi <span className='badge bg-danger'>{user.name}</span>
                    </h1>
                )}
            </div>
        </div>
    );
};

export default HiUser;

